<template>
  <div id="app">
    <h3 @click="back" style="border-bottom:1px solid #ccc;padding:0px 0 10px 10px;cursor:pointer">返回</h3>
    <div class="info">
      <!--<img class="" src="/static/images/1.jpg"/>-->
      <div class=" mid">
        <div class="title">{{platformTask.title}}</div>
        <div class="date">发起时间：{{platformTask.startDate}}</div> 
      </div>
      <div class="count">
        <div class="label"> 查到相似处</div>
        <div class="number">{{totalResultCount}}</div>
        <!-- <button class="btn" @click="dowFile">下载报告</button> -->
      </div>
      <div class="clear_both"></div>
    </div> 
    <div style="font-size: 14px;margin-top:50px;margin-bottom:20px;padding:0px 20px;">比对网址 （{{totalWebCount}}个地址）</div>
    <div v-for="(item,key) in summary" :key="key" class="result">
      <div class="l">{{item.title}}</div>
      <div class="m">{{item.count}}处</div>
      <div class="r" @click="view(platformTask.taskId,item.wid)">查看</div>
      <div class="clear_both"></div>
    </div>
  </div>
</template>
<script>
import {taskSummaryApi,resultDowApi} from  '@/service/allApi'
export default {
  data(){
    return {
      taskId:0,
      platformTask:{},
      summary:[],
      totalResultCount:0,
      totalWebCount:0
    }
  },
  mounted(){
    this.taskId = this.$route.query.taskId
    this.loadData()
  },
  methods:{
    back(){
      window.location.href = "/searching"
    },
    view(taskId,wid){
     
      window.location.href = "/resultview?taskId=" + taskId + "&wid=" + wid 
    },
    async loadData(){
      const options = {
        taskId:this.taskId
      }
      const res = await taskSummaryApi(options)
      // console.log(res);
      if(res.data.code == 100){
        this.platformTask = res.data.data
        const msummary = this.platformTask.summary
        if(msummary){
          this.totalWebCount = msummary.length
          this.summary =  msummary
          for(let i = 0 ; i < msummary.length ; i ++){
            this.totalResultCount += msummary[i].count
          }
        }
      }
    },
    // async  dowFile(){
    //   if(this.summary.length == 0){
    //       this.$message({
    //         message: '不存在相似处，下载报告失败',
    //         type: 'error'
    //       });
    //       return
    //   }
    //   var data = {
    //       taskId:this.taskId
    //   }

    //   window.open("http://www.dmid.com.cn/api/file/resultDow?taskId="+this.taskId, '_blank')
    // }
  }

}
</script>


<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/CheckResult.css"></style>


// WEBPACK FOOTER //
// src/components/iframe/CheckResult.vue